import React from "react";
import { userDisplayName } from "@/utils/userDisplayName";
import type { MappedAuthUser } from "@/utils/mapWorkosUserProfile";

export type UserAccountMenuIdentityUser = Pick<
  MappedAuthUser,
  | "email"
  | "name"
  | "fullname"
  | "first_name"
  | "last_name"
  | "display_name"
  | "company_id"
  | "company_name"
>;

interface UserAccountMenuIdentityProps {
  user: UserAccountMenuIdentityUser;
  className?: string;
}

/**
 * Non-interactive identity block for account menus (name, company, email).
 */
export function UserAccountMenuIdentity({
  user,
  className = "",
}: UserAccountMenuIdentityProps) {
  const displayName = userDisplayName(user);
  const companyLabel = user.company_name?.trim();

  return (
    <div
      className={`pointer-events-none select-none border-b border-slate-200 px-3 py-2.5 dark:border-white/10 ${className}`}
      role="presentation"
      data-testid="user-account-menu-identity"
    >
      <div className="truncate text-sm font-medium text-slate-900 dark:text-slate-100">
        {displayName}
      </div>
      {companyLabel ? (
        <div className="truncate text-xs text-slate-600 dark:text-slate-400">
          {companyLabel}
        </div>
      ) : null}
      <div className="truncate text-xs text-slate-500 dark:text-slate-500">
        {user.email}
      </div>
    </div>
  );
}
